import { getProgrammeList } from '@ben/columbia/api';
import Select from '@ben/orion/deprecated-select';
import { useQuery } from '@tanstack/react-query';
import { forwardRef, useMemo } from 'react';

interface IProgrammeDropdown {
  selected?: number;
  onChange: (pk: number) => void;
  hasError?: boolean;
  isActive?: boolean;
  disabled?: boolean;
  errorMessage?: string;
  employer?: string;
}

const ProgrammeDropdown = forwardRef(
  (
    {
      onChange,
      selected,
      employer,
      hasError,
      isActive,
      disabled,
      errorMessage,
    }: IProgrammeDropdown,
    ref
  ) => {
    const { isLoading, data } = useQuery({
      queryKey: [`programmeListFor-${employer}`],
      queryFn: () => getProgrammeList(employer),
      enabled: !!employer,
    });

    const options = useMemo(() => {
      return isLoading || !data
        ? []
        : data?.map((item) => ({ key: item.id.toString(), label: item.name }));
    }, [data, isLoading]);

    if (isLoading) return false;

    return (
      <Select
        name={isActive ? 'Programme' : 'Programme (optional)'}
        ref={ref}
        showSearch={true}
        defaultValue={selected?.toString()}
        options={options}
        onChange={(selection) => {
          onChange(Number.parseInt(selection as string));
        }}
        hasError={!!employer && hasError}
        errorMessage={errorMessage}
        disabled={!employer || disabled}
        width="376px"
      />
    );
  }
);

ProgrammeDropdown.displayName = 'ProgrammeDropdown';

export default ProgrammeDropdown;
